export default __webpack_public_path__ + "static/media/menugradient.d41d0aaa.png";